// extracted by mini-css-extract-plugin
export var alertIcon = "_oc-0";